/// Port of mobile/lib/game/audio/audio_assets.dart.

const audioRoot = '/assets/audio';

export const audioAssets = {
  music: `${audioRoot}/music.mp3`,
  jump: `${audioRoot}/jump.wav`,
  die: `${audioRoot}/die.wav`,
  point: `${audioRoot}/point.wav`,
} as const;

export const allAudioAssets: readonly string[] = [
  audioAssets.music,
  audioAssets.jump,
  audioAssets.die,
  audioAssets.point,
];
